import type { QuickStepIconId } from '../store/schema/QuickStepIconId';
import FlashRegular from 'owa-fluent-icons-svg/lib/icons/FlashRegular';
import Delete from 'owa-fluent-icons-svg/lib/icons/DeleteRegular';
import MailRead from 'owa-fluent-icons-svg/lib/icons/MailReadRegular';
import FolderArrowRight from 'owa-fluent-icons-svg/lib/icons/FolderArrowRightRegular';
import Tag from 'owa-fluent-icons-svg/lib/icons/TagRegular';
import ArrowForward from 'owa-fluent-icons-svg/lib/icons/ArrowForwardRegular';
import MailAttachRegular from 'owa-fluent-icons-svg/lib/icons/MailAttachRegular';
import Flag from 'owa-fluent-icons-svg/lib/icons/FlagRegular';
import CheckmarkRegular from 'owa-fluent-icons-svg/lib/icons/CheckmarkRegular';

export function getIconNameFromIconId(id: QuickStepIconId) {
    // It's possible the map doesn't contain the type, if so return the default icon type
    return ActionTypeToIconNameMap.get(id) ?? FlashRegular;
}

// Why are we keying a string to a string here, you may ask? This way, if we update icons
// to new version, we can just do it here, the user's saved quick step won't be broken
const ActionTypeToIconNameMap: Map<QuickStepIconId, string> = new Map<QuickStepIconId, string>([
    ['markAsRead', MailRead],
    ['markAsUnread', MailRead],
    ['delete', Delete],
    ['softDelete', Delete],
    ['moveTo', FolderArrowRight],
    ['copyTo', FolderArrowRight],
    ['category', Tag],
    ['clearCategories', Tag],
    ['forwardTo', ArrowForward],
    ['forwardAsAttachment', MailAttachRegular],
    ['flag', Flag],
    ['clearFlags', Flag],
    ['markComplete', CheckmarkRegular],
    [null, FlashRegular], // Default to the quick steps icon
]);
